import { hasPermits } from 'directives'

import { shouldShowRateManagementTabs } from 'utils/tpsIntegration'

const directives = {
  hasPermits
}

export default {
  name: 'rate-management-tabs',
  directives,
  computed: {
    showTabs () {
      return shouldShowRateManagementTabs(this.$store.state.locations.active, this.$route.params.id)
    }
  },
  data () {
    return {
      locId: this.$route.params.id
    }
  },
}
